import { useEffect, useState } from "react";

import { Button } from "primereact/button";
import { Chart } from "primereact/chart";

import ChartDataLabels from 'chartjs-plugin-datalabels';

const colors = ["#2ecc71", "#2980b9", "#f1c40f", "#0F0", "#8e44ad"];

export default function GraficoClassificacaoPorcentagem({ data, setores, months, tipo }) {
    const [chartData, setChartData] = useState({});
    const [col, setCol] = useState("p-col-12");

    const options = {
        maintainAspectRatio: false,
        plugins: {
            datalabels: {
                display: 'auto',
                rotation: -22,
                anchor: 'center',
                align: 'center',
                formatter: (value) => {
                    return Intl.NumberFormat("pt-BR", {
                          maximumFractionDigits: tipo === "porcentagem" ? 2 : 0,
                        }).format(value) + (tipo === "porcentagem" ? "%" : "");
                  },
                font: {
                    size: 14,
                    weight: 'bold',
                    color: "#000"
                },
                color: "#2c3e50"
            },
            title: {
                display: true,
                font: {
                    size: 18
                },
                text: tipo === "porcentagem" ? "Porcentagem de Defeitos por Setor" : "Total de Defeitos por Setor (m)"
            }
        },
        scales: {
            x: {
                stacked: true
            },
            y: {
                stacked: true
            }
        }
    }

    useEffect(() => {
        let datasets = [];

        setores.forEach((setor, index1) => {
            let valuesSetor = [];

            months.forEach((month, index) => {
                let filteredData = data.find((element) => {
                    return element.setor === setor.nome && parseInt(element.mes) === index + 1;
                });

                if(filteredData) {
                    valuesSetor.push(filteredData[tipo]);
                } else {
                    valuesSetor.push(0);
                }
            });

            datasets.push({
                label: setor.nome,
                data: valuesSetor,
                backgroundColor: colors[index1]
            });
        });

        const _chartData = {
            labels: months,
            datasets: datasets
        }

        setChartData(_chartData);

    }, [data, months, setores, tipo]);

    return (
        <div className={col}>
            <Button
                icon="pi pi-search"
                onClick={() => {
                    setCol(col === "p-col-6" ? "p-col-12" : "p-col-6")
                }}
            />
            <Chart 
                data={chartData}
                height="350px"
                width="100%"
                options={options}
                plugins={[ChartDataLabels]}
                type="bar"
            />
        </div>
    )
}